import { RegistryItem } from "@schemas/agreements/schema";
import ShipAgreementForm from "view/agreements/components/form/ShipAgreementForm";
import ShipAgreementDetails from "view/agreements/components/details/ShipAgreementDetails";
import { AgreementTypeEnum, CalculationMethodType } from "__generated__/graphql";

export const ShipSchema: RegistryItem = {
	[AgreementTypeEnum.Ship]: {
		Form: ShipAgreementForm,
		Details: ShipAgreementDetails,
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.Manual,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
			"agreement.costType": { rules: { hidden: true } },
			"agreement.ships": { path: "ships", rules: { required: true } },
			"agreement.conditions": { rules: { hidden: true } },
			"agreement.invoiceTo": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
			"calculationMethod.description": { rules: { hidden: true } },
		},
		toInput: (form) => ({
			ships: form.ships?.map(x => x.id) ?? [],
		}),
		toForm: (agreement) => ({
			ships: agreement.ships ?? [],
		}),
		isNotDeclarable: true,
	},
};
